var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntakeInsightsIconContained(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 25,
    viewBox: "0 0 36 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35.62,
    height: 25,
    rx: 6,
    fill: "#F3F8FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3867 18.573C18.3867 18.716 18.2697 18.833 18.1267 18.833H16.5745C16.4315 18.833 16.3145 18.716 16.3145 18.573C16.3145 18.43 16.4315 18.313 16.5745 18.313H18.1267C18.2697 18.313 18.3867 18.43 18.3867 18.573Z",
    fill: "#3B4651"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2655 17.3694C19.2655 17.5124 19.1485 17.6294 19.0055 17.6294H15.6957C15.5527 17.6294 15.4357 17.5124 15.4357 17.3694C15.4357 17.2264 15.5527 17.1094 15.6957 17.1094H19.0055C19.1485 17.1094 19.2655 17.2264 19.2655 17.3694Z",
    fill: "#3B4651"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6175 7.14078C19.6737 6.23858 18.4309 5.77838 17.1231 5.83818C14.7363 5.94998 12.7603 7.90518 12.6251 10.2894C12.5523 11.5712 12.9865 12.7984 13.8497 13.7448C14.4711 14.426 14.8117 15.2684 14.8117 16.116V16.1654C14.8117 16.311 14.9287 16.4254 15.0717 16.4254H19.6295C19.7725 16.4254 19.8895 16.311 19.8895 16.1654V16.116C19.8895 15.2476 20.2145 14.426 20.8047 13.7968C21.6289 12.918 22.0839 11.7688 22.0839 10.565C22.0839 9.25979 21.5639 8.04299 20.6175 7.14078Z",
    fill: "#2B79C2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntakeInsightsIconContained);
export default __webpack_public_path__ + "static/media/intake-insights-icon-contained.56d68ff189419d57f46a6c2158fbb0c4.svg";
export { ForwardRef as ReactComponent };